// 3rd party libs
import React, { ReactElement } from 'react';
// components
import { KPICard, StateOverTimeCard, Typography } from 'components';
// data
import styled from 'styled-components';
import { NestedRow } from 'components/StateOverTimeCard';
// Hook
import { DataRenderer } from 'components/machine-health';
import { useSyncZoom } from 'providers';
import { MachineStateColors } from 'common/pages/fleetV2/settings/protein/colors';

interface Props {
  title?: string;
  data: NestedRow[];
  intervalSpacing?: boolean;
  isLoading?: boolean;
  error?: string;
  isMachineMode?: boolean;
  hideTitle?: boolean;
}
const MachineModesContainer = styled.div`
  > * {
    border: none;
    border-radius: 0;
  }
`;

const MachineModesGraphWidget = ({
  title,
  data,
  intervalSpacing = true,
  isLoading = false,
  error,
  hideTitle
}: Props): ReactElement => {
  const { zoomedDomain, onBrushDomainChangeEnd, resetZoom, undoZoom } = useSyncZoom();

  const heading = title ? title : hideTitle ? '' : 'Machine Modes';

  return (
    <DataRenderer isLoading={isLoading}>
      <KPICard>
        <MachineModesContainer>
          {error && (
            <Typography color="negativeRed" style={{ marginLeft: '2rem', marginTop: '1.5rem' }}>
              {error}
            </Typography>
          )}
          <StateOverTimeCard
            subHeadingComponent={
              <Typography weight="bold" size="1rem" mb="1.25rem">
                {heading}
              </Typography>
            }
            title={''}
            nestedData={data}
            stateColors={MachineStateColors}
            barCornerRadius={6}
            intervalSpacing={intervalSpacing ? 5 : 0}
            tickLabelPadding={30}
            chartPadding={{ top: 10, right: 30, bottom: 65, left: 150 }}
            sync={true}
            brush={{
              zoomedDomain,
              onBrushDomainChangeEnd,
              resetZoom,
              undoZoom
            }}
            hideStateCodes={true}
            isMachineMode={heading === 'Machine Modes' ? true : false}
          />
        </MachineModesContainer>
      </KPICard>
    </DataRenderer>
  );
};

export default MachineModesGraphWidget;
